module.exports = __webpack_public_path__ + "media/images/icon__info--white@2x-ddd4cb2fb5b05330838f61f15721adb0.png";